import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.BRAND_DETAILS_REQUEST_NEW:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.BRAND_DETAILS_SUCCESS_NEW:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.BRAND_DETAILS_FAILURE_NEW:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_BRAND_DETAILS_DATA_NEW:
      return {
        ...state,
        data: {},
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
